<cb-dialog class="flex-col" dialogHeading="Request Pricing On Lots">
    <form class="flex-col flex" #form="ngForm">
        <cb-table class="cb-margin-top cb-margin-bottom-3x" [loaded]="loaded">
            <thead cbTableHead>
                <tr>
                    <td>Lot #</td>
                    <td>Job #</td>
                    <td>Scheme Status</td>
                    <td>Applied Concept</td>
                    <td style="text-align: center; width: 150px">Request Pricing</td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (lot of filteredLots | cbSortByPipe: 'lotNumber' : 'asc'; track lot) {
                    <tr cbTableRow>
                        <cb-td-text [value]="lot.lotNumber"></cb-td-text>
                        <cb-td-text [value]="lot.jobNumber"></cb-td-text>
                        <td>
                            @if (!lot.designSchemeStatusId) {
                                <cb-td-text value="Any"></cb-td-text>
                            }
                            @if (lot.designSchemeStatusId) {
                                <cb-td-enum
                                    [value]="lot.designSchemeStatusId"
                                    [enum]="DESIGN_SCHEME_STATUS_ENUM"
                                >
                                </cb-td-enum>
                            }
                        </td>
                        <cb-td-text [value]="lot.appliedConceptName"></cb-td-text>
                        <td style="text-align: center; width: 150px">
                            <mat-checkbox
                                [checked]="lot.$shouldApplyConcept"
                                (change)="clicked(lot, form.form)"
                            >
                            </mat-checkbox>
                        </td>
                    </tr>
                }
                @if (lots?.length < 1 && loaded) {
                    <tr>
                        <td colspan="17">
                            <mat-icon class="cb-grey">info</mat-icon>
                            &nbsp;No Lots have been added to this Release Stage
                        </td>
                    </tr>
                }
            </tbody>
        </cb-table>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="isSaveDisabled(form.form)"
            (cbClick)="requestPricing()"
            [clickLimit]="1"
        >
            Request Pricing
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
